module.exports = __webpack_public_path__ + "static/media/Mosaique_11.143eaad2.png";